import React, {useState} from 'react';
import PhaseTabCell from "../PhaseTabCell";
import WeekTabCell from "../WeekTabCell";
import checkIcon from "../assets/check_circle_24dp_4DD4B1_FILL1_wght400_GRAD0_opsz24.svg";

function ProfileDataModal({foods, setShowFoods}) {

    const [calendarLayout, setCalendarLayout] = useState(false);

    function showCalendarLayout(boolean){
        if (boolean){
            setCalendarLayout(true);
        } else {
            setCalendarLayout(false);
        }
    }

    function closeModal(){
        setShowFoods(false);
    }

    return (
        <div className="modal" style={{display: "flex"}}>
            <div className="modal-content-centered">
                <span onClick={closeModal} className="close">&times;</span>
                <div className="modal-section">
                    <div style={{margin: "auto"}}>
                        <a style={{fontSize: "21px", fontWeight: "500"}}>{}</a>
                        <div>
                            <div className={"progress-layout-tabs" + ( (!calendarLayout) ? " progress-layout-tabs-selected" : "")} onClick={() => showCalendarLayout(false)}>{"Foods"}</div>
                            <div className={"progress-layout-tabs" + ( calendarLayout ? " progress-layout-tabs-selected" : "")} onClick={() => showCalendarLayout(true)}>{"Exercises"}</div>
                        </div>

                        <ul>
                        {foods.map(food => (
                            <li key={food.id}>{food.name || 'Unnamed food'}</li>
                        ))}
                    </ul>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ProfileDataModal;